import template from './registration-with-card.html';

export class RegistrationWithCardController {
  constructor($log, $mdDialog, access, currentClassRoom, classRooms) {
    'ngInject';
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.cardId = '';
    this._activeStep = 1;
    this.students = null;
    this.access = access;
    this.currentClassRoom = currentClassRoom;
    this.classRooms = classRooms;
  }

  get activeStep() {
    return this._activeStep;
  }

  closeDialog() {
    this.$mdDialog.cancel();
  }

  nextStep() {
    this._activeStep += 1;
  }

  setStudents(students) {
    this.students = students;
  }
}

export const RegistrationWithCard = {
  bindings: {
  },
  controller: RegistrationWithCardController,
  template
};
